import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    documentId: 0,
    documentInfo: {}
  }
};
const documentItemSlice = createSlice({
  name: "documentItem",
  initialState,
  reducers: {
    loadDocument: (state, action) => {
      state.value = {
        documentId: action.payload.documentId,
        documentInfo: action.payload
      };
    }
  }
});
export const { loadDocument } = documentItemSlice.actions;
export default documentItemSlice.reducer;
